// Always absolute, even when VITE_API_BASE_URL is a relative path like "/api".
//
// That resolution is not cosmetic, it is what stops a doubled prefix. axiosInstance is created
// with `baseURL: API_BASE_URL`, and every generated NSwag client is *also* constructed with
// API_BASE_URL, so a client builds "/api/auth/token/refresh" and axios then prepends its own
// "/api" on top: "/api/api/auth/token/refresh". Axios only skips that prepend when the request
// URL is already absolute, which it always was while this value was hardcoded to
// http://localhost:7165/api.
//
// Resolving against the page's own origin keeps both halves working: the generated clients get an
// absolute URL, and useExploreCourses' bare axiosInstance.get('/courses/explore') still resolves
// through baseURL. It also keeps the relative env value usable from a phone on the LAN, where
// "localhost" would mean the phone itself. Vite proxies /api to the Functions host.
const rawApiBaseUrl: string =
  import.meta.env.VITE_API_BASE_URL || 'http://localhost:7165/api';

export const API_BASE_URL =
  typeof window === 'undefined'
    ? rawApiBaseUrl
    : new URL(rawApiBaseUrl, window.location.origin)
        .toString()
        .replace(/\/$/, '');
export const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID;
export const MAP_BOX_KEY = import.meta.env.VITE_MAP_BOX_KEY;
export const MAX_DROPDOWN_PAGE_SIZE = 99999; // Used for fetching all records in dropdowns/select lists
